import $ from 'jquery';
import heightAnimate from '../../scripts/util/animate/heightAnimate';
import TweenLite from 'TweenLite';
import Power2 from 'TweenLite';
import 'scrollToPlugin';
import isMobile from 'ismobilejs';
import {enableScroll, disableScroll} from '../page/page';

export default class Header {
	constructor(options) {
		const defaults = {
			el: '.js-header',
			dom: {
				body: '.js-body',
				navTop: '.js-nav-top',
				private: '.js-nav-private',
				sidebar: '.js-nav-sidebar',
				list: '.js-nav-list',
				navOpen: '.js-nav-open',
				navClose: '.js-nav-close',
				nav: '.js-nav-body',
				searchOpen: '.js-search-open',
				searchClose: '.js-search-close',
				search: '.js-search-form',
				shadow: '.js-header-shadow'
			},
			classes: {
				navTop: {
					state: {
						opened: 'header__nav-top_state_opened'
					}
				},
				nav: {
					state: {
						opened: 'header__nav_state_opened',
						fixed: 'header__nav_state_fixed'
					}
				},
				search: {
					state: {
						opened: 'header__search-form_state_opened'
					}
				},
				shadow: {
					state: {
						active: 'header__shadow_active'
					}
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
	}

	getDom() {
		this.$navTop = this.$el.find(this.options.dom.navTop);
		this.$private = this.$el.find(this.options.dom.private);
		this.$sidebar = this.$el.find(this.options.dom.sidebar);
		this.$list = this.$el.find(this.options.dom.list);
		this.$navOpen = this.$el.find(this.options.dom.navOpen);
		this.$navClose = this.$el.find(this.options.dom.navClose);
		this.$nav = this.$el.find(this.options.dom.nav);
		this.$searchOpen = this.$el.find(this.options.dom.searchOpen);
		this.$searchClose = this.$el.find(this.options.dom.searchClose);
		this.$search = this.$el.find(this.options.dom.search);
		this.$shadow = this.$el.find(this.options.dom.shadow);
	}

	openNav = () => {
		this.$nav.addClass(this.options.classes.nav.state.opened);
		this.$shadow.addClass(this.options.classes.shadow.state.active);

		disableScroll();
	};


	setNavFixed = () => {
		if (isMobile.apple.device) {
			this.$nav.addClass(this.options.classes.nav.state.fixed);
		}
	};

	closeNav = e => {
		if ($(e.target).hasClass('js-nav-body')) {
			this.$nav.removeClass(this.options.classes.nav.state.opened);
			this.$shadow.removeClass(this.options.classes.shadow.state.active);
			enableScroll();
		}
	};

	openSearch = () => {
		this.$search.addClass(this.options.classes.search.state.opened);
	};

	searchClose = e => {
		e.preventDefault();
		this.$search.find('.js-field-input').val('');
		this.$search.removeClass(this.options.classes.search.state.opened);
	};

	toggleSidebar = e => {
		const $target = $(e.target);
		const $menuToggle = $target.closest(this.options.dom.navTop);
		const openClass = this.options.classes.navTop.state.opened;

		if ($menuToggle.hasClass(openClass)) {
			heightAnimate(this.$sidebar, 0.4, 'close');
		} else {
			heightAnimate(this.$sidebar, 0.4);
		}

		if (!$menuToggle.hasClass(openClass)) {
			TweenLite.to(this.$list, 0.4, {
				scrollTo: {y: 0},
				ease: Power2.easeInOut
			});
		}

		this.$navTop.toggleClass(openClass);
	};

	render() {
		if (this.$el.length) {
			this.getDom();
			this.setNavFixed();
			this.$navOpen.on('click', this.openNav);
			this.$nav.on('click', this.closeNav);
			this.$navClose.on('click', this.closeNav);
			this.$searchOpen.on('click', this.openSearch);
			this.$searchClose.on('click', this.searchClose);
			this.$private.on('click', this.toggleSidebar);
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/header/header.js
 **/